import http from './http';

class UserSettings {
    constructor(http) {
        this.http = http;
        this.settings = null;
    }

    async loadAsync() {
        if (!this.settings) {
            const { data } = await this.http.get('/account-settings');
            this.settings = data;
        }

        return this.settings;
    }

    async getAsync(key, defaultValue = null) {
        const settings = await this.loadAsync();
        return settings[key] ?? defaultValue;
    }

    async getDisplayTypeAsync() {
        return this.getAsync('request-store.display-type');
    }

    clearCache() {
        this.settings = null;
    }
}

const userSettings = new UserSettings(http);

export { UserSettings };
export default userSettings;
